export class ErrorMessages {
    static messages(label = "This field", maxFileSize?: number, errorData?: any): { type: string; message: string }[] {
        return [
            {
                type: 'invalid',
                message: `${label} is invalid`,
            },
            {
                type: "required",
                message: `${label} is required`,
            },
            {
                type: "unique",
                message: `${label} must be unique`,
            },
            {
                type: "notBlank",
                message: `${label} can not be blank`,
            },
            {
                type: "email",
                message: `${label} is invalid`,
            },
            {
                type: "noSpace",
                message: `Blank space not allowed`,
            },
            {
                type: "minlength",
                message: `Too short`,
            },
            {
                type: "maxlength",
                message: `Too long`,
            },
            {
                type: "max",
                message: errorData?.max
                    ? `${label} must not exceed ${errorData.max}. Given: ${errorData.actual}`
                    : `Too long`,
            },
            {
                type: "min",
                message: errorData?.min
                    ? `${label} must be at least ${errorData.min}. Given: ${errorData.actual}`
                    : `Too short`,
            },
            {
                type: "invalidPhoneNumber",
                message: `${label} is invalid`,
            },
            {
                type: "validatePhoneNumber",
                message: `${label} is invalid`,
            },
            {
                type: "invalidInput",
                message: 'Email or Asin is Invalid',
            },
            {
                type: "mustBeTrue",
                message: 'You must confirm before proceeding',
            },
            {
                type: "mustBeAnswered",
                message: 'This question must be answered',
            },
            {
                type: "invalidAsin",
                message: 'ASIN is invalid',
            },
            {
                type: "invalidYear",
                message: 'Please enter a valid year between 1900 and current year',
            },
            {
                type: "fileSize",
                message: 'File size is too large. 1MB Maximum'
            },
            {
                type: "asinAlreadyInUse",
                message: 'This ASIN is already in use'
            },
            {
                type: 'duplicateEntry',
                message: `${label ? `${label} with name `: ''} '${errorData}' has already been added. Duplicate entries are not allowed.`
            },
            {
                type: 'maxFileSize',
                message: `Uploaded file is too large! ${maxFileSize ? `(Max: ${maxFileSize}MB)` : ''}`
            },
            {
                type: 'missingMotorcyclePlateNumbers',
                message: `Incomplete: Some riders' have missing motorcycle plate number`
            },
            {
                type: 'maxDateRange',
                message: `Date range must not exceed ${7} days`
            }
        ];
    }
}
